import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const HeaderWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: ${({ compact }) => (compact ? "56px" : "auto")};
  padding: ${({ compact }) => (compact ? "6px 8px" : "0")};
  box-sizing: border-box;
  cursor: ${({ clickable }) => (clickable ? "pointer" : "default")};
`;

const HeaderText = styled.div`
  font-size: ${({ compact }) => (compact ? "16px" : "20px")};
  color: ${({ color }) => color || "rgba(0,0,0,.5)"};
  font-weight: ${({ weight }) => weight || "600"};
  text-align: center;
  line-height: 1.3;
  white-space: ${({ compact }) => (compact ? "normal" : "nowrap")};
  overflow-wrap: anywhere;
  word-break: break-word;
  hyphens: auto;
  max-width: 100%;
`;

const HeaderDetails = ({ title, color, onClick, weight, compact }) => {
  return (
    <HeaderWrap
      compact={compact}
      clickable={compact}
      onClick={onClick}
      title={typeof title === "string" ? title : undefined}
    >
      <HeaderText color={color} weight={weight} compact={compact}>
        {title}
      </HeaderText>
    </HeaderWrap>
  );
};

HeaderDetails.defaultProps = {
  color: null,
  weight: null,
  compact: false,
  onClick: () => {}
};

HeaderDetails.propTypes = {
  title: PropTypes.string.isRequired,
  color: PropTypes.string,
  onClick: PropTypes.func,
  weight: PropTypes.string,
  compact: PropTypes.bool
};

export default HeaderDetails;
